import React, { ReactNode, memo } from "react";
import { Spin } from "antd";

interface LoadingViewProps {
  isLoading: boolean;
  children: ReactNode;
}

const LoadingView = memo<LoadingViewProps>(({ isLoading, children }) => {
  return <Spin spinning={isLoading}>{children}</Spin>;
});

export default LoadingView;
